import { create } from 'zustand'
import * as ComplianceApi from '../../../API/ComplianceAPI'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import { toast } from 'react-toastify'
import { toaster } from 'src/Common/ui/Toaster'

const initialState = {
    compLoading: false,
    complianceFor: [],
    complianceList: [],
    compById: {},
    compByIdError: '',
    complianceListError: '',
    compForOptions: [],
    compForError: '',
    complianceCategory: [],
    compCategory: '',
    complianceSubCategory: [],
    compSubCategory: '',
    compFrequency: [],
    compFrequencyError: '',
    compUom: [],
    compUomError: '',
    modifiedDueDate: {},
    complianceTimelineData: [],
    compLoading2: false,
    transferCompDetailData: [],
    notificationId: null,
    isSelectCompliance: false,
    seededCompDataList: [],
    selectedSeededCompDataList: [],
    tabCountLoading: false,
    tabCount: {},
    seededCompLoading: false,
    selectedSeedLoading: false
}

const ComplianceStore = (set, get) => ({
    initialState,
    compLoadOverRide: (value) => {
        set({ compLoading2: value })
    },
    setIsSelectCompliance: (value) => {
        set({ isSelectCompliance: value })
    },
    setNotification: (id) => {
        set((state) => ({
            ...state, // Preserve existing state
            notificationId: id
        }))
    },
    compLoadOn: async () => {
        set({ compLoading: true })
    },
    compLoadOff: () => {
        set({ compLoading: false })
    },
    createCompliance: async (data, loginId, complianceId) => {
        set({ compLoading: true })
        try {
            const response = await ComplianceApi.createCompliance(data, loginId, complianceId)
            set({ compLoading: false })
            return response
        } catch (error) {
            set({ compLoading: false })
            throw error
        }
    },
    getCompByRegulationId: async (regId) => {
        try {
            set({ seededCompLoading: true })
            const response = await ComplianceApi.GetCompByRegId(regId)
            if (response.data) {
                set({ seededCompDataList: response.data, seededCompLoading: false })
                return response.data
            } else {
                set({ seededCompLoading: false, seededCompDataList: [] })
            }
        } catch (error) {
            set({ seededCompLoading: false })
        }
    },
    getOneTimeCompliance: async (regId) => {
        try {
            set({ seededCompLoading: true })
            const response = await ComplianceApi.GetOneTimeCompliance(regId)
            if (response.data) {
                set({ seededCompDataList: response.data, seededCompLoading: false })
                return response.data
            } else {
                set({ seededCompLoading: false, seededCompDataList: [] })
            }
        } catch (error) {
            set({ seededCompLoading: false })
        }
    },
    getSelectedCompliance: async (orgId, typeId) => {
        set({ selectedSeedLoading: true })
        try {
            const response = await ComplianceApi.GetSelectedCompliance(orgId, typeId)
            set({ selectedSeedLoading: false, selectedSeededCompDataList: response.data })
            return response.data
        } catch (error) {
            set({ selectedRegulationsError: error, selectedSeedLoading: false })
        }
    },
    getComplianceStatusTabCount: async (orgId, typeId) => {
        set({ tabCountLoading: true })
        try {
            const response = await ComplianceApi.GetStatusTabCount(orgId, typeId)
            set({ tabCountLoading: false, tabCount: response.data })
            return response.data
        } catch (error) {
            set({ selectedRegulationsError: error, tabCountLoading: false })
        }
    },
    submitSeedCompliance: async (data, orgId, loginId, regId) => {
        set({ compLoading: true })
        try {
            const response = await ComplianceApi.SubmitSeedCompliance(data, orgId, loginId, regId)
            return response
        } catch (error) {
            set({ allRegulationsError: error, compLoading: false })
        }
    },
    createUserCompliance: async (data, msg) => {
        set({ compLoading: true })
        try {
            await ComplianceApi.createUserCompliance(data)
            // eslint-disable-next-line react/react-in-jsx-scope
            toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{msg || 'Compliance updated successfully'}</p></p>, {
                position: 'top-right',
                theme: 'light'
            })
            set({ compLoading: false })
        } catch (error) {
            set({ compLoading: false })
        }
    },
    createApproveCompliance: async (data, msg) => {
        set({ compLoading: true })
        try {
            await ComplianceApi.approveCompliance(data)
            // eslint-disable-next-line react/react-in-jsx-scope
            toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{msg || 'Compliance updated successfully'}</p></p>, {
                position: 'top-right',
                theme: 'light'
            })
            set({ compLoading: false })
        } catch (error) {
            set({ compLoading: false })
        }
    },
    getAllCompliance: async (regId, frequency, orgId, selectMonth, userId, cutoff, typeId) => {
        set({ compLoading: true })
        try {
            const response = await ComplianceApi.GetAllComp(regId, frequency, userId, orgId, selectMonth, cutoff, typeId)
            set({ compLoading: false, complianceList: response.data })
        } catch (error) {
            set({ complianceListError: error.message, compLoading: false })
        }
    },
    GetTransferComplianceDetails: async (notificationId) => {
        set({ compLoading: true })
        try {
            const response = await ComplianceApi.ViewTransferComplianceDetails(notificationId)
            set({ compLoading: false, transferCompDetailData: response.data })
        } catch (error) {
            set({ compByIdError: error.message, compLoading: false, transferCompDetailData: [] })
        }
    },
    AcknowledgeTransferComplianceDetails: async (notificationId, loginId) => {
        set({ compLoading: true })
        try {
            await ComplianceApi.AcknowledgeTransferCompliance(notificationId, loginId)
            toaster('success', 'Compliance acknowledged successfully')

            set({ compLoading: false })
        } catch (error) {
            set({ compByIdError: error.message, compLoading: false })
        }
    },
    TransferComplianceDetail: async (payload) => {
        set({ compLoading: true })
        try {
            const response = await ComplianceApi.TransferComplianceDetail(payload)
            toaster('success', 'Compliance transferred, awaiting acknowledgment')

            set({ compLoading: false })
            return response
        } catch (error) {
            set({ compLoading: false })
            throw error
        }
    },
    GetComplianceById: async (complianceId, isAdmin, userId) => {
        set({ compLoading: true, compById: {} })
        try {
            const response = await ComplianceApi.GetCompById(complianceId, isAdmin, userId)
            set({ compLoading: false, compById: response.data })
        } catch (error) {
            set({ compByIdError: error.message, compLoading: false })
        }
    },
    ClearCompliance: () => {
        set({ compById: {} })
    },
    ViewAnswerComplianceById: async (complianceId, dueby, userId) => {
        try {
            const response = await ComplianceApi.GetCompByIdAnswer(complianceId, dueby, userId)
            set({ compById: response.data })
        } catch (error) {
            set({ compByIdError: error.message, compLoading: false })
        }
    },
    getCompFor: async () => {
        set({ compLoading: true })
        try {
            const response = await ComplianceApi.GetAllComplianceFor()
            set({

                complianceFor: response.data,
                compForOptions: response.data.map((item) => {
                    return {
                        id: item.id,
                        value: item.name
                    }
                }),
                compLoading: false
            })
        } catch (error) {
            set({ compForError: error, compLoading: false })
        }
    },
    getCompCategory: async () => {
        set({ compLoading: true })
        try {
            const response = await ComplianceApi.GetAllCompCategory()
            set({ complianceCategory: response.data, compLoading: false })
        } catch (error) {
            set({ compCategoryError: error, compLoading: false })
        }
    },
    getCompSubCategory: async () => {
        set({ compLoading: true })
        try {
            const response = await ComplianceApi.GetAllCompSubCategory()
            set({ complianceSubCategory: response.data, compLoading: false })
        } catch (error) {
            set({ compSubCategoryError: error, compLoading: false })
        }
    },
    getCompFrequency: async () => {
        set({ compLoading: true })
        try {
            const response = await ComplianceApi.getAllCompFrequency()
            set({ compFrequency: response.data, compLoading: false })
        } catch (error) {
            set({ compFrequencyError: error, compLoading: false })
        }
    },
    getCompUom: async () => {
        set({ compLoading: true })
        try {
            const response = await ComplianceApi.GetAllCompUom()
            set({ compUom: response.data })
        } catch (error) {
            set({ compUomError: error, compLoading: false })
        }
    },
    putModifiedDueDate: async (data) => {
        set({ compLoading: true })
        try {
            await ComplianceApi.updateModifiedDueDate(data)
            // eslint-disable-next-line react/react-in-jsx-scope
            toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{'Due date updated successfully'}</p></p>, {
                position: 'top-right',
                theme: 'light'
            })
            set({ compLoading: false })
        } catch (error) {
            set({ compLoading: false })
        }
    },
    getModifiedDueDate: async (compId, dueBy) => {
        set({ compLoading: true })
        try {
            const response = await ComplianceApi.GetModifiedDueDate(compId, dueBy)
            set({ modifiedDueDate: response.data, compLoading: false })
        } catch (error) {
            set({ compLoading: false })
        }
    },
    getComplianceTimeline: async (compId, dueby) => {
        set({ compLoading: true })
        try {
            const response = await ComplianceApi.GetComplianceTimeline(compId, dueby)
            set({ complianceTimelineData: response.data, compLoading: false })
        } catch (error) {
            set({ compLoading: false })
        }
    }

})

export const useCompStore = create(devtools(immer(ComplianceStore)))
// Pre-made getter hook

// Pre-made setter function
export const setIsSelectCompliance = (value) => {
    return useCompStore.getState().setIsSelectCompliance(value)
}
export const getCompSeedByRegulationId = (value) =>
    useCompStore.getState().getCompByRegulationId(value)
export const getOneTimeCompliance = (value) =>
    useCompStore.getState().getOneTimeCompliance(value)
export const getSelectedCompliance = (orgId, typeId) =>
    useCompStore.getState().getSelectedCompliance(orgId, typeId)
export const getComplianceStatusTabCount = (orgId, typeId) =>
    useCompStore.getState().getComplianceStatusTabCount(orgId, typeId)
export const submitSeedCompliance = (data, orgId, loginId, regId) =>
    useCompStore.getState().submitSeedCompliance(data, orgId, loginId, regId)
export const ClearCompliance = () =>
    useCompStore.getState().ClearCompliance()
